"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketInventoryConfigurationInput_1 = require("./GetBucketInventoryConfigurationInput");
var GetBucketInventoryConfigurationOutput_1 = require("./GetBucketInventoryConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketInventoryConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketInventoryConfiguration",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?inventory"
    },
    input: {
        shape: GetBucketInventoryConfigurationInput_1.GetBucketInventoryConfigurationInput
    },
    output: {
        shape: GetBucketInventoryConfigurationOutput_1.GetBucketInventoryConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketInventoryConfiguration.js.map